exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntbody td[data-v-4847df82] {\n  width: 8%;\n}\ntbody td.col2[data-v-4847df82] {\n    width: 16%;\n}\ntbody td.name[data-v-4847df82] {\n    width: 28%;\n}\ntbody > tr.normal-temperature[data-v-4847df82] {\n  background: #FDEAEA;\n}\ntbody > tr.normal-temperature[data-v-4847df82]:nth-of-type(even) {\n    background: #FBC6C6;\n}\ntbody > tr > td.num[data-v-4847df82] {\n  text-align: right;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4847df82","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/parts/ReportTableRow.vue
// module id = p4LB
// module chunks = 1